import { IEntity } from './entity';
import { IUserToken } from './userToken';
import { IVenture } from './venture';

export interface IUser {
  id?: number;
  firstName: string;
  lastName?: string;
  fullName?: string;
  email: string;
  password?: string;
  roles: userRoles[];
  ventureId?: number;
  ventures?: IVenture[];
  entities?: IEntity[];

  venture?: { id: number, name: string };
  createdDate?: Date;
  updatedDate?: Date;
  expirationDate?: Date;
  lastAccessDate?: Date;
}

export enum userRoles {
  sysAdmin = 'sysAdmin',
  admin = 'admin',
  auditor = 'auditor',
  holding = 'holding',
  venturer = 'venturer',
  operator = 'operator',
  visitor = 'visitor',
  third = 'third',
}

export const userRolesNames = {
  sysAdmin: 'SysAdmin',
  admin: 'Administrador',
  auditor: 'Solid',
  holding: 'Corporativo',
  venturer: 'Gerenciador',
  operator: 'Operador',
  third: 'Terceiro',
  visitor: 'Visitante'
};

export const globalRoles = [userRoles.sysAdmin, userRoles.admin, userRoles.holding];

export const allModulesRoles = [
  userRoles.sysAdmin, userRoles.admin, userRoles.holding, userRoles.auditor, userRoles.venturer
];

export const ventureRelationType = {
  [userRoles.sysAdmin]: 0, // SysAdmin
  [userRoles.admin]: 0, // Administrador
  [userRoles.holding]: 0, // Corporativo
  [userRoles.auditor]: 1, // Solid
  [userRoles.venturer]: 2, // Gerenciador
  [userRoles.operator]: 3, // Operador
  [userRoles.third]: 3, // Terceiro
  [userRoles.visitor]: 4, // Visitante
};

export const allowedRolesFor = (user: IUserToken): userRoles[] => {
  if (!user)
    return [];
  switch (user.roles[0]) {
  case userRoles.admin:
  case userRoles.sysAdmin:
    return Object.keys(userRoles).map(role => userRoles[role]);
  case userRoles.auditor:
    return [userRoles.venturer, userRoles.operator, userRoles.third];
  case userRoles.holding:
    return [userRoles.holding, userRoles.venturer, userRoles.operator, userRoles.third, userRoles.visitor];
  case userRoles.venturer:
    return [userRoles.operator, userRoles.third];
  case userRoles.operator:
    return [userRoles.third];
  default:
    return [];
  }
};
